import { Component, computed, inject, Input, signal } from '@angular/core';
import { LipEcouponInformationComponent } from '@web-nx-ng-tsc/ecoupon';
import { IInFoResponse } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { EcouponServiceService } from '../core/service/ecoupon-service.service';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-ecoupon-information',
  imports: [LipEcouponInformationComponent],
  templateUrl: './ecoupon-information.component.html',
  styleUrl: './ecoupon-information.component.scss',
})
export class EcouponInformationComponent {
  statusSignal = signal<string>('');
  imgInFor = signal<string>('/assets/icon/icon-complete.png');
  private readonly ecouponService = inject(EcouponServiceService);
  private readonly loggingService = inject(LoggingService);

  errMsgStatus = this.ecouponService.getErrorStatusSignal();
  hourExpire = this.ecouponService.getHourExpireSignal();

  // computed เพื่อให้ข้อความอัปเดตเองเมื่อ errMsgStatus หรือ hourExpire เปลี่ยน
  eCouponMessage = computed<IInFoResponse>(() => {
    const status = this.errMsgStatus();
    if (status === 1) {
      return {
        img: '/assets/icon/icon-warning.png',
        message:
          'ขณะนี้มีผู้ได้รับสิทธิ์ครบตามจำนวนที่กำหนดแล้ว ขอขอบคุณที่ให้ความสนใจในโปรโมชั่นนี้ท่านสามารถติดตามโปรโมชั่นดีๆ ได้ผ่านทาง https://www.toyotires.in.th/',
      };
    }
    if (status === 2 || status === 0) {
      return {
        img: '/assets/icon/icon-warning.png',
        message: ' ขออภัย ยังไม่มีรายการส่งเสริมการขายในช่วงเวลานี้',
      };
    }
    return {
      img: '/assets/icon/icon-complete.png',
      message:
        ' ขอบคุณที่สนใจเข้าร่วมกิจกรรมของ TOYO รหัสส่วนลดถูกส่งไปยัง เบอร์โทรศัพท์ ที่ท่านได้ลงทะเบียน ผ่านทาง SMS เรียบร้อยแล้ว',
      message2: ` *รหัสส่วนลด มีอายุการใช้งาน ${this.hourExpire()} ชม. นับจากที่ได้รับรหัสส่วนลด หากไม่มีการใช้งานรหัสส่วนลดภายในเวลาที่กำหนด ระบบจะยกเลิกรหัสส่วนลดนี้โดยอัตโนมัติ และหมายเลขโทรศัพท์และทะเบียนรถคันนี้จะไม่สามารถรับสิทธิ์ได้อีกเป็นเวลา 30 วัน นับจากวันที่รหัสส่วนลดถูกยกเลิก`,
    };
  });

  @Input() set status(value: string) {
    this.statusSignal.set(value);
    this.loggingService.log('status', value);
    this.loggingService.log('hourExpire on status set', this.hourExpire());
  }
}
